/* Copyright (c) 2019-2020, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { Observable, fromEvent, merge } from 'rxjs';
import { distinctUntilChanged, mapTo, startWith } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class NetworkStatusCheckService {
    constructor() {}

    /**
     * Subscribe to receive notifications when online status has changed.
     *
     * Note: This observable will never complete and will only return success
     * so there is no need to add an error/catchError block to the subscription.
     */
    onlineStatusChanged(): Observable<boolean> {
        const onlineEvent$ = fromEvent(window, 'online').pipe(mapTo(true));
        const offlineEvent$ = fromEvent(window, 'offline').pipe(mapTo(false));
        return merge(onlineEvent$, offlineEvent$).pipe(startWith(window.navigator.onLine), distinctUntilChanged());
    }

    /**
     * Get the current online status
     */
    isOnline(): boolean {
        return window.navigator.onLine;
    }
}
